"use strict";
// Copyright © 2022 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormParser = void 0;
const abstract_1 = require("./abstract");
class FormParser extends abstract_1.AbstractParser {
    /**
     * Parses the passed-in EmbedToken to HTML.
     *
     * @param src - EmbedToken to parse.
     *
     * @returns - HTML representation of the passed-in EmbedToken.
     */
    parse(src) {
        return '<section class="form"></section>';
    }
}
exports.FormParser = FormParser;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZm9ybS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wYXJzZXJzL2Zvcm0udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLCtCQUErQjs7O0FBSS9CLHlDQUEyQztBQUUzQyxNQUFhLFVBQVcsU0FBUSx5QkFBeUI7SUFDdkQ7Ozs7OztPQU1HO0lBQ0ksS0FBSyxDQUFFLEdBQWM7UUFDMUIsT0FBTyxrQ0FBa0MsQ0FBQTtJQUMzQyxDQUFDO0NBQ0Y7QUFYRCxnQ0FXQyIsInNvdXJjZXNDb250ZW50IjpbIi8vIENvcHlyaWdodCDCqSAyMDIyIE1vdmUgQ2xvc2VyXG5cbmltcG9ydCB7IEZvcm1Ub2tlbiB9IGZyb20gJy4uL2NvbnRyYWN0cydcblxuaW1wb3J0IHsgQWJzdHJhY3RQYXJzZXIgfSBmcm9tICcuL2Fic3RyYWN0J1xuXG5leHBvcnQgY2xhc3MgRm9ybVBhcnNlciBleHRlbmRzIEFic3RyYWN0UGFyc2VyPEZvcm1Ub2tlbj4ge1xuICAvKipcbiAgICogUGFyc2VzIHRoZSBwYXNzZWQtaW4gRW1iZWRUb2tlbiB0byBIVE1MLlxuICAgKlxuICAgKiBAcGFyYW0gc3JjIC0gRW1iZWRUb2tlbiB0byBwYXJzZS5cbiAgICpcbiAgICogQHJldHVybnMgLSBIVE1MIHJlcHJlc2VudGF0aW9uIG9mIHRoZSBwYXNzZWQtaW4gRW1iZWRUb2tlbi5cbiAgICovXG4gIHB1YmxpYyBwYXJzZSAoc3JjOiBGb3JtVG9rZW4pOiBzdHJpbmcge1xuICAgIHJldHVybiAnPHNlY3Rpb24gY2xhc3M9XCJmb3JtXCI+PC9zZWN0aW9uPidcbiAgfVxufVxuIl19